export default function ({ $config, route, redirect }) {
  const isMaintenance = $config.displayMaintenanceNotice;

  if (route.path.includes('maintenance')) {
    return;
  }

  if (isMaintenance) {
    return redirect('/maintenance');
  }
}